/**
 * PDF Viewer (pdf.js-based)
 *
 * Exposes `content/web/viewer.html` — the bundled pdf.js viewer UI — to `<all_urls>`
 * with no `use_dynamic_url`. One fetch of that path against `chrome-extension://<id>/`
 * confirms the extension: the ID is in the URL and the file is served only when the
 * extension is installed.
 *
 * The filename `viewer.html` is generic, but that only risks the path being renamed in
 * a future release — never a false positive, because the ID scopes it to this extension
 * alone.
 *
 * Manifest verified against version 4.6.129.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'oemmndcbldboiebfnladdacbdfmadadm';

export const pdfViewer: ExtensionDefinition = {
  id: ID,
  name: 'PDF Viewer',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 1_000_000,
  notes:
    'Single static WAR (content/web/viewer.html) on <all_urls>. Detection is a single ' +
    'fetch and conclusive; the only fragility is the path changing across releases.',
  signals: [
    {
      id: 'war-viewer-html',
      kind: 'web-accessible-resource',
      description:
        'Fetch content/web/viewer.html — the pdf.js viewer page the extension exposes ' +
        'to every origin.',
      weight: 1,
      run: () => probeFetch(ID, 'content/web/viewer.html'),
    },
  ],
};
